import { StoryboardFunctionRegistryFactory } from "./StoryboardFunctionRegistryFactory";

export const { storyboardFunctions, registerStoryboardFunctions } =
  StoryboardFunctionRegistryFactory();
